function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export default (function (theme) {
  return _defineProperty({
    rowContainer: {
      flexDirection: 'row',
      alignItems: 'center'
    },
    rowLabel: {
      marginRight: theme.spacing.unit * 3
    },
    rowHelperText: {
      marginTop: 0
    }
  }, theme.breakpoints.down('sm'), {
    rowLabel: {
      marginRight: theme.spacing.unit * 2
    }
  });
});